import { Link } from 'react-router-dom';

const BlogItemGrid = ({ blogitem }) => {

    const truncateText = (text, limit = 360) => {
        if (!text) return "";
        return text.length > limit ? text.slice(0, limit) + "..." : text;
    };
    
    const getThumbnailPath = (path) => {
        if (!path) return path;

        const dotIndex = path.lastIndexOf(".");
        if (dotIndex === -1) return path; // no extension case

        const name = path.substring(0, dotIndex);
        const ext = path.substring(dotIndex);

        return `${name}-thumbnail${ext}`;
    }

    if (!blogitem?.paramlink) return null;

    return (
        <>
            <div class="full-col col-lg-4 col-md-6">
                <div class="single-blog-inner" data-aos="fade-up"
                    data-aos-duration="800">
                    <div class="thumb">
                        <Link to={`/blog/${blogitem?.paramlink}`} className="no-underline">
                            <img src={getThumbnailPath(blogitem?.mediapath)} alt={blogitem?.title} />
                        </Link>
                        <ul class="blog-meta">
                            <li><i class="fa fa-user-o"></i> Author: {blogitem.authorname}</li>
                            <li><i class="fa fa-calendar"></i> Date: {blogitem.posteddate}</li>
                        </ul>
                    </div>
                    <div class="details">
                        <h4><Link to={`/blog/${blogitem?.paramlink}`} className="no-underline blog-title-a">{blogitem?.title}</Link></h4>
                        <p className='justify-text'>{truncateText(blogitem.shortdescription)}</p>
                        <Link to={`/blog/${blogitem?.paramlink}`} class="read-more-btn"><i class="bx bx-chevron-right"></i></Link>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BlogItemGrid;